/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Services_TitleInputs */

const en_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Service Description`)
};

const de_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Leistungsbeschreibung`)
};

const fr_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Description des services`)
};

const es_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Descripción del servicio`)
};

const it_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Descrizione del servizio`)
};

const nl_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Dienstbeschrijving`)
};

const pl_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Opis usługi`)
};

const fi_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Palvelun kuvaus`)
};

const da_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Tjenestebeskrivelse`)
};

const sv_agb_services_title = /** @type {(inputs: Agb_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Tjänstebeskrivning`)
};

/**
* | output |
* | --- |
* | "4. Service Description" |
*
* @param {Agb_Services_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_services_title = /** @type {((inputs?: Agb_Services_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Services_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_services_title(inputs)
	if (locale === "fr") return fr_agb_services_title(inputs)
	if (locale === "es") return es_agb_services_title(inputs)
	if (locale === "it") return it_agb_services_title(inputs)
	if (locale === "nl") return nl_agb_services_title(inputs)
	if (locale === "pl") return pl_agb_services_title(inputs)
	if (locale === "fi") return fi_agb_services_title(inputs)
	if (locale === "da") return da_agb_services_title(inputs)
	if (locale === "sv") return sv_agb_services_title(inputs)
	return en_agb_services_title(inputs)
});